import { Component, OnInit } from '@angular/core';
import { CategoryService } from '../../services/category.service';
import { Category } from '../../models/category.model';
import { CartComponent } from '../cart/cart.component';
import { ModalController } from '@ionic/angular';
import { GlobalService } from '../../services/global.service';
import { NavController } from '@ionic/angular';
import { catalogo } from '../../models/catalogo.model';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.scss'],
})
export class CategoryComponent implements OnInit {

  categorias: Category[] = [];
  categoria: Category[] = [];
  catal: catalogo;
  oneColumn: Boolean = false;
  list: Boolean = false;
  menu = 'datos';
  searchTerm = '';
  nombre = '';
  indice = 0;
  nophoto = '';

  constructor(private navController: NavController, public global: GlobalService, private modalController: ModalController,
    private categoryService: CategoryService) { }

  ngOnInit() {
    console.log('Entra'+this.indice);
    this.nophoto = this.global.url + 'imagenes/NOFOTO.JPG';
    //this.getCategories();
  }

  vertodas(){
    this.global.filtroCat = '';
    this.getCategories();
  }

  ionViewWillEnter() {
    this.categoria = [];
    this.getCategories();
  }

  onError(item) {
    console.log(item.imagen);
    item.imagen = this.nophoto;
  }
  
  // Get list of categories
  getCategories() {
    console.log('Get');
    this.categoryService.categoryList().then(categories => {
      this.categorias = categories;
      console.log(this.categorias);
      if(this.global.filtroCat != ''){
        // tslint:disable-next-line:prefer-for-of
        console.log(this.categorias.length);
        
        for (let i = 0; i < this.categorias.length; i++) {
          console.log(this.categorias[i].codigo.toString());
          if ( this.categorias[i].codigo.toString() == this.global.filtroCat) {
            this.categoria.push(this.categorias[i]);
          }
        }
      } else {
        this.categoria = this.categorias;
      }
    });
  }
  vercategoria(codigo, nombre) {
    console.log('Si llega: ' + codigo);
    this.global.catProducts = codigo;
    this.global.catName = nombre;
    //this.router.navigate(['/tabs/cateproducts']);
    this.navController.navigateForward(['/tabs/cateproducts']);
  }

  menuSel(seleccion){
    console.log(seleccion);
    this.menu = seleccion.codigo;
    this.nombre = seleccion.nombre;
    
    this.catal = seleccion.Catalogos;
    console.log(this.catal)
  }

  // Go to cart page function
  async gotoCartPage() {
    const modal = await this.modalController.create({
      component: CartComponent
    });
    
    return await modal.present();
  }
}
